// extracted by mini-css-extract-plugin
module.exports = {"posts":"Search_posts__2qP0T","hidden":"Search_hidden__5VYFF"};